module.exports = __webpack_public_path__ + "static/img/10.ade4386.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/10.png
// module id = e4E+
// module chunks = 0